import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Autocomplete from '@afosto/app-components-react/Autocomplete';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import findObjectInArray from '@afosto/utils/array/findObjectInArray';
import translations from './translations';

const ChangeRouteForm = ({ onCancel, onSubmit, order, orderItem, showQuantity }) => {
  const intl = useIntl();
  const orderReference = findObjectInArray(orderItem?.references?.orders ?? [], 'id', order?.id);
  const { warehouse } = orderReference ?? {};
  const { collect_route_id: collectRouteId, delivery_route_id: deliveryRouteId } = warehouse ?? {};
  const deliveryRoute = findObjectInArray(orderItem?.delivery_routes ?? [], 'id', deliveryRouteId);
  const collectRoute = findObjectInArray(orderItem?.collect_routes ?? [], 'id', collectRouteId);

  const form = useForm({
    defaultValues: {
      collectRoute: collectRoute
        ? { ...collectRoute, label: collectRoute.name, value: collectRoute.id }
        : null,
      deliveryRoute: deliveryRoute
        ? { ...deliveryRoute, label: deliveryRoute.name, value: deliveryRoute.id }
        : null,
      quantity: orderItem?.quantity ?? orderItem?.ids?.length,
    },
    onCancel,
    onSubmit,
  });
  const { setValue, watch } = form;
  const collectRouteValue = watch('collectRoute');
  const deliveryRouteValue = watch('deliveryRoute');

  const handleChangeCollectRoute = (ev, newValue) => {
    if (
      deliveryRouteValue &&
      newValue &&
      !newValue?.delivery_routes?.includes(deliveryRouteValue?.id)
    ) {
      setValue('deliveryRoute', null);
    }

    setValue('collectRoute', newValue);
  };

  const availableDeliveryRoutes = (orderItem?.delivery_routes ?? [])
    .map(route => ({
      ...route,
      label: route.name,
      value: route.id,
    }))
    .filter(route => {
      if (collectRouteValue) {
        return collectRouteValue?.delivery_routes?.includes(route?.id);
      }

      return true;
    });

  return (
    <Form form={form}>
      <Autocomplete
        name="collectRoute"
        label={intl.formatMessage(translations.fields.collectRoute.label)}
        options={(orderItem?.collect_routes ?? []).map(route => ({
          ...route,
          label: route.name,
          value: route.id,
        }))}
        onChange={handleChangeCollectRoute}
        value={collectRouteValue}
      />
      <Autocomplete
        name="deliveryRoute"
        label={intl.formatMessage(translations.fields.deliveryRoute.label)}
        options={availableDeliveryRoutes}
      />
      {showQuantity && (
        <TextField
          name="quantity"
          label={intl.formatMessage(translations.fields.quantity.label)}
          type="number"
          inputProps={{
            min: 1,
            max: orderItem?.quantity,
          }}
        />
      )}
    </Form>
  );
};

ChangeRouteForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  order: PropTypes.object,
  orderItem: PropTypes.object,
  showQuantity: PropTypes.bool,
};

ChangeRouteForm.defaultProps = {
  onCancel: undefined,
  onSubmit: undefined,
  order: undefined,
  orderItem: undefined,
  showQuantity: true,
};

export default ChangeRouteForm;
